import React, { useEffect, useState } from 'react'
import BossDialog from '../../../components/BossDialog';
import { useTranslation } from '../../../locale/useTranslation';
import bossAIPng from '../../../img/BOSS-AI.png';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { ResponseTable } from './ResponseTable';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import { utility } from '../../../framework/utility/utilityProvider';
import { ApplicationConfigurationKeys, ENTITYNAME, TOAST_TYPES } from '../../../framework/constant/constant';
import * as API from '../../../framework/API/api';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import ToastNotification from '../../../components/ToastNotification';


const BossAssistantIcon = (props) => {

  const enableBossAI = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.EnableBossAI) ?? false;

  const lang = useTranslation();

  let onDataLoad = props.onDataLoad ?? (() => alert('BOSS AI clicked!'));
  let tooltip = props.tooltip ?? 'Boss AI';
  let popupTtle = props.popupTtle ?? 'Generate Meta Data';
  let iconSize = props.iconSize ?? '45px';
  let showLanguage = props.showLanguage ?? false;

  const [dataItem, setDataItem] = useState({});
  const [data, setData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showMetaData, setShowMetaData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPop, setIsPop] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (props.mediaEpisodeEntity?.Title && props.mediaEpisodeEntity?.Title.length !== 0) {
      setDataItem(prev => ({
        ...prev,
        Title: props.mediaEpisodeEntity.Title,
        Languages: prev.Languages && prev.Languages.length > 0
          ? prev.Languages
          : languages.filter((x) => x.Description === "English")
      }));
    }
  }, [props.mediaEpisodeEntity, languages]);

  useEffect(() => {
    loadCombo();
  }, []);

  const loadCombo = async () => {
    const langRes = await API.getDataLookup(ENTITYNAME.Language, { query: ['Archive', '=', false] });
    setLanguages(langRes.data);

    if (props.mediaEpisodeEntity?.Title) {
      setDataItem({
        ...dataItem,
        Title: props.mediaEpisodeEntity.Title,
        Languages: langRes.data.filter((x) => x.Description == "English")
      });
    }
  }

  const onCloseForm = () => {
    setShowForm(false);
    setDataItem({});
    setHasLoaded(false);
    setData({});
  }

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  }

  const handleMainButtonClick = () => {
    let title = dataItem.Title;
    let currentLanguages = dataItem.Languages;

    if (!title && props.mediaEpisodeEntity?.Title) {
      title = props.mediaEpisodeEntity.Title;
      currentLanguages = languages.filter((x) => x.Description === "English");
      setDataItem({
        ...dataItem,
        Title: title,
        Languages: currentLanguages
      });
    }

    generateData(title, false, true);
  };

  const generateData = async (title, show = false, isFirstTime = false) => {
    if (!show) setIsPop(true);

    setShowForm(true);

    if (isFirstTime && (!title || title.length === 0)) {
      return;
    }

    if (!isFirstTime && show && (!title || title.length === 0)) {
      ToastNotification({
        type: TOAST_TYPES.INFO,
        title: lang.info_message_title,
        message: lang.please_enter_title_error_message
      });
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        title,
        languages: dataItem.Languages
      };

      const response = await onDataLoad(payload);

      if (response.success) {
        setData(response.data);
        setHasLoaded(true);
      } else {
        ToastNotification({
          type: TOAST_TYPES.ERROR,
          title: lang.invalid_error_message_title,
          message: response.message
        });
      }
    } catch (error) {
      console.error(error);

      ToastNotification({
        type: TOAST_TYPES.ERROR,
        title: lang.invalid_error_message_title,
        message: lang.failed_to_generate_data_error_message
      });
    } finally {
      setIsLoading(false);
      setTimeout(() => setIsPop(false), 300);
    }
  };

  const onConfirm = () => {

    setIsLoading(false);
    onCloseForm();

    //SET META DATA
    props.setMetaData(data);

  }

  return (
    !enableBossAI
      ? <></>
      : <div style={props.style ?? { position: 'absolute', top: '15.2%', right: '1%', display: 'flex' }}>
        <button
          title={tooltip}
          onClick={handleMainButtonClick}
          style={{
            borderRadius: '50%',
            border: 'none',
            background: 'transparent',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: iconSize,
            height: iconSize,
            cursor: isLoading ? 'not-allowed' : 'pointer',
            outline: 'none',
            boxShadow: 'none'
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <i
              className="fa fa-spinner fa-spin fa-2xl"
              style={{
                color: '#3498db',
                fontSize: `calc(${iconSize} * 0.6)`,
                width: iconSize,
                height: iconSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            />
          ) : (
            <img
              src={bossAIPng}
              alt="Boss AI"
              className={isPop ? 'popup-animate' : ''}
              style={{ width: iconSize, height: iconSize }}
            />
          )}
        </button>

        {showForm && <BossDialog
          title={`${popupTtle} ${dataItem.Title ? "- " + dataItem.Title : ''}`}
          showBossAIIcon={true}
          onClose={onCloseForm}
          width={"680px"}
        >

          <div className="row mb-3">
            <div className={showLanguage ? "col-5" : "col-10"}>
              <label htmlFor="">{lang.title_label}</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="Title"
                value={dataItem.Title || ''}
                onChange={onChange}
              />
            </div>
            {showLanguage && <div className="col-5">
              <label htmlFor="">{lang.language_label}</label>
              <MultiSelect
                data={languages}
                dataItemKey="_id"
                textField="Description"
                value={dataItem.Languages || []}
                onChange={onChange}
                name={"Languages"}
                style={{ width: '100%' }}
              />
            </div>}
            <div className="col-2" style={{ marginTop: '20px' }}>
              <ActionButton
                style={{ width: "100%", height: "30px" }}
                btnColor={'primary'}
                title={lang.show_button_tooltip}
                name={"Show"}
                onClick={() => generateData(dataItem.Title, true)}
                isLoading={isLoading}
              />
            </div>
          </div>

          <div className='row'>
            {isLoading ? (<Loader height="300px" description={props.description} bossAI={true} />) : hasLoaded ? (
              <>
                <ResponseTable onClose={() => setShowMetaData(false)} value={data} popup={false} height="300px" />
                <DialogActionsBar >
                  <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={onConfirm}
                    disabled={Object.keys(data).length === 0}
                  >
                    {lang.confirm_button_text}
                  </button>
                  <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={onCloseForm}>
                    {lang.cancel_button_text}
                  </button>
                </DialogActionsBar>
              </>
            ) : (
              <div className="col-12 d-flex flex-column align-items-center justify-content-center text-muted" style={{ height: '350px' }}>
                <i className="fa fa-magic fa-2x mb-3" style={{ color: '#3498db', opacity: 0.7 }} />
                <h5 className="mb-2">{lang.ready_to_generate_data_label}</h5>
                <p className="text-center px-4" style={{ maxWidth: '400px', fontSize: '0.9rem', lineHeight: '1.4' }}> {lang.boss_ai_gernerate_data_message} </p>
              </div>
            )}
          </div>
        </BossDialog>
        }
      </div>
  )
}

export default BossAssistantIcon